import React, { useEffect, useState } from "react";
import AddCaseStatusPopup from "../Component/AddCaseStatusPopup";
import { API_BASE_URL } from "../config";

export default function CaseStatus() {
  const [status, setStatus] = useState([]);
  const [newStatus, setNewStatus] = useState({ courtName: "", location: "" });
  const [editingStatus, setEditingStatus] = useState(null);

  // Fetch all courts
  useEffect(() => {
    fetchStatus();
  }, []);

  const fetchStatus = async () => {
    try {
      const token = localStorage.getItem("token");
      const res = await fetch(`${API_BASE_URL}/api/CaseStatus/GetCaseStatus`, {
          headers: { Authorization: `Bearer ${token}` },
      });
      if (res.ok) {
        const data = await res.json();
        setStatus(data);
      } else {
        console.error("Failed to fetch status");
      }
    } catch (err) {
      console.error("Error:", err);
    }
  };

  // Add new court
  const handleAddStatus = async (newStatus) => {
    // e.preventDefault();
    try {
      const token = localStorage.getItem("token");
      const res = await fetch(`${API_BASE_URL}/api/CaseStatus/add`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(newStatus),
      });
      if (res.ok) {
        fetchStatus(); // Refresh list
        setNewStatus({ courtName: "", location: "" });
        alert("Status added successfully!");
      } else {
        console.error("Failed to add status");
      }
    } catch (err) {
      console.error("Error:", err);
    }
  };

  // Delete court
  const handleDeleteStatus = async (id) => {
    if (!window.confirm("Are you sure you want to delete this status?")) return;

    try {
      const token = localStorage.getItem("token");
      const res = await fetch(`${API_BASE_URL}/api/Court/deletecourt/${id}`, {
        method: "DELETE",
        headers: { Authorization: `Bearer ${token}` },
      });
      if (res.ok) {
        setStatus((prev) => prev.filter((c) => c.id !== id));
        alert("Court deleted successfully!");
      } else {
        console.error("Failed to delete court");
      }
    } catch (err) {
      console.error("Error:", err);
    }
  };

  // Update court
  const handleUpdateStatus = async (e) => {
    e.preventDefault();
    try {
      const token = localStorage.getItem("token");
      const res = await fetch(`${API_BASE_URL}/api/CaseStatus/update/${editingStatus.caseStatusId}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(editingStatus),
      });
      if (res.ok) {
        fetchStatus();
        setEditingStatus(null);
        alert("Status updated successfully!");
      } else {
        console.error("Failed to update stutas");
      }
    } catch (err) {
      console.error("Error:", err);
    }
  };

  return (
    <div style={{ padding: "20px" }}>
      <h2>Manage Case Status</h2>
      
      <AddCaseStatusPopup onAddStatus={handleAddStatus} />

      {/* Court Table */}
      <table border="1" cellPadding="10" style={{ width: "100%", marginTop: "20px" }}>
        <thead style={{ background: "#f4f4f4" }}>
          <tr>
            <th>Status</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {status.length > 0 ? (
            status.map((status) => (
              <tr key={status.caseStatusId}>
                <td>
                  {editingStatus?.caseStatusId === status.caseStatusId ? (
                    <input
                      type="text"
                      value={editingStatus.statusName}
                      onChange={(e) =>
                        setEditingStatus({ ...editingStatus, statusName: e.target.value })
                      }
                    />
                  ) : (
                    status.statusName
                  )}
                </td>
                <td>
                  {editingStatus?.caseStatusId === status.caseStatusId ? (
                    <>
                      <button onClick={handleUpdateStatus}>Save</button>
                      <button onClick={() => setEditingStatus(null)}>Cancel</button>
                    </>
                  ) : (
                    <>
                      <button onClick={() => setEditingStatus(status)}>Edit</button>
                      <button onClick={() => handleDeleteStatus(status.statusId)}>Delete</button>
                    </>
                  )}
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="3">No Status found</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}
